import { render } from "./PartnerGemini.vue?vue&type=template&id=43adc482"
import script from "./PartnerGemini.vue?vue&type=script&lang=js"
export * from "./PartnerGemini.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__